var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmountIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#1ABC9C",
    fillOpacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 20.5904C38 20.9845 37.7967 21.4715 37.1869 22.0273C36.5766 22.5836 35.6379 23.1304 34.3933 23.6103C31.9107 24.5674 28.4132 25.1807 24.5 25.1807C20.5868 25.1807 17.0893 24.5674 14.6067 23.6103C13.3621 23.1304 12.4234 22.5836 11.8131 22.0273C11.2033 21.4715 11 20.9845 11 20.5904C11 20.1962 11.2033 19.7093 11.8131 19.1534C12.4234 18.5971 13.3621 18.0503 14.6067 17.5704C17.0893 16.6133 20.5868 16 24.5 16C28.4132 16 31.9107 16.6133 34.3933 17.5704C35.6379 18.0503 36.5766 18.5971 37.1869 19.1534C37.7967 19.7093 38 20.1962 38 20.5904Z",
    stroke: "#1ABC9C",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7842 20.4866V30.2839C10.7842 32.9271 16.6852 34.9158 24.5004 34.9158C32.3156 34.9158 38.2166 32.9271 38.2166 30.2839V20.4866",
    stroke: "#1ABC9C",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4865 24.0134V34.2026",
    stroke: "#1ABC9C",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7568 25.1892L21.7568 34.5946",
    stroke: "#1ABC9C",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0273 25.1892L28.0273 34.5946",
    stroke: "#1ABC9C",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5135 24.0134V34.2026",
    stroke: "#1ABC9C",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmountIcon);
export default __webpack_public_path__ + "static/media/amount_icon.46ffd6d6eab450d91a8fdf1bef0041b4.svg";
export { ForwardRef as ReactComponent };